import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { MentionNameStatus } from '@atlaskit/mention';
import { config } from '@atlaskit/smart-common';
import { graphqlQuery } from './graphqlUtils';
var buildUsersQuery = function buildUsersQuery(accountIds) {
  return {
    query: "query usersQuery($accountIds: [ID!]!) {\n    users(accountIds: $accountIds) {\n      name\n      accountId\n    }\n  }",
    variables: {
      accountIds: accountIds
    }
  };
};
var makeRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, accountIds) {
    var query;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          query = buildUsersQuery(accountIds);
          return _context.abrupt("return", graphqlQuery(url, query));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function makeRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var DefaultMentionNameResolver = /*#__PURE__*/function () {
  function DefaultMentionNameResolver(baseUrl) {
    _classCallCheck(this, DefaultMentionNameResolver);
    this.baseUrl = baseUrl;
    this.cache = new Map();
  }
  _createClass(DefaultMentionNameResolver, [{
    key: "lookupName",
    value: function () {
      var _lookupName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var _data$users, url, data, userInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!this.cache.has(id)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", {
                id: id,
                name: this.cache.get(id),
                status: MentionNameStatus.OK
              });
            case 3:
              url = config.getGraphQLUrl(this.baseUrl);
              _context2.next = 6;
              return makeRequest(url, [id]);
            case 6:
              data = _context2.sent;
              userInfo = (_data$users = data.users) === null || _data$users === void 0 ? void 0 : _data$users.find(function (user) {
                return user.accountId === id;
              });
              return _context2.abrupt("return", userInfo ? {
                id: id,
                name: userInfo.name,
                status: MentionNameStatus.OK
              } : {
                id: id,
                status: MentionNameStatus.UNKNOWN
              });
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", {
                id: id,
                status: MentionNameStatus.UNKNOWN
              });
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 11]]);
      }));
      function lookupName(_x3) {
        return _lookupName.apply(this, arguments);
      }
      return lookupName;
    }()
  }, {
    key: "cacheName",
    value: function cacheName(id, name) {
      this.cache.set(id, name);
    }
  }]);
  return DefaultMentionNameResolver;
}();